import { CustomerName } from '../models/be/Customer';
import FilterSettings from '../models/be/FilterSettings';
import { ToFrom } from '../models/RootState';

export const SET_CANDIDATE_TEXT_SEARCH = 'SET_CANDIDATE_TEXT_SEARCH';
export const SET_REFEREE_TEXT_SEARCH = 'SET_REFEREE_TEXT_SEARCH';
export const SET_FILTER_SETTINGS = 'SET_FILTER_SETTINGS';
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const SET_TIME_FILTER = 'SET_TIME_FILTER';
export const SET_SELECTED_CUSTOMER_ID = 'SET_SELECTED_CUSTOMER_ID';
export const ADD_FIELD_NAME_FOR_FILE_BEING_UPLOADED = 'ADD_FIELD_NAME_FOR_FILE_BEING_UPLOADED';
export const REMOVE_FIELD_NAME_FOR_FILE_BEING_UPLOADED = 'REMOVE_FIELD_NAME_FOR_FILE_BEING_UPLOADED';

interface Action {
	type: string;
}

export interface ValueAction<T> extends Action {
	value: T;
}

const setValueAction =
	<T>(type: string) =>
	(value: T): ValueAction<T> => ({ type, value });

export const setCandidateTextSearch = setValueAction<string>(SET_CANDIDATE_TEXT_SEARCH);

export const setRefereeTextSearch = setValueAction<string>(SET_REFEREE_TEXT_SEARCH);

export const setFilterSettings = setValueAction<FilterSettings>(SET_FILTER_SETTINGS);

export const setCustomerDetails = setValueAction<CustomerName>(SET_CUSTOMER_DETAILS);

export const setTimeFilter = setValueAction<ToFrom>(SET_TIME_FILTER);

export const setSelectedCustomer = setValueAction<number>(SET_SELECTED_CUSTOMER_ID);

export const addFieldNameForFileUpload = (fieldName: string) => ({
	type: ADD_FIELD_NAME_FOR_FILE_BEING_UPLOADED,
	fieldName
});

export const removeFieldNameForFileUpload = (fieldName: string) => ({
	type: REMOVE_FIELD_NAME_FOR_FILE_BEING_UPLOADED,
	fieldName
});
